/** Resolução contextual da matriz O.S.; a RPC sempre revalida o estado persistido. */
export function resolveServiceOrderPermission<T extends { phase_id: string; is_responsible_only: boolean }>(rows: T[], phaseId: string, action: keyof T, isResponsible?: boolean): boolean {
  const generic = rows.find(row => row.phase_id === phaseId && !row.is_responsible_only);
  const specific = rows.find(row => row.phase_id === phaseId && row.is_responsible_only);
  // Sem entidade, somente descobre destinos potenciais; não autoriza cartões individualmente.
  if (isResponsible === undefined) return generic?.[action] === true || specific?.[action] === true;
  return (isResponsible ? specific ?? generic : generic)?.[action] === true;
}

/** O padrão vale exclusivamente na criação, nunca ao abrir uma edição legada. */
export function serviceOrderInitialResponsible(creatorId: string | null, editing: boolean, savedId?: string | null): string | null {
  return editing ? savedId ?? null : creatorId;
}